import { useCallback, useContext, useEffect, useState } from 'react';
import { Footer } from '../../components/footer';
import { HomeContext } from '../../contexts/contexHome';
import { HomeMain } from '../../styles/home';
import logo from '../../assets/logos/jales_nova-logo.png';
import { IoExit } from 'react-icons/io5';
import { apiJalles } from '../../services/api';
import { toast } from 'react-toastify';

export const Home = () => {
  const { navigate, headerApi, user } = useContext(HomeContext);
  const unityExists = sessionStorage.getItem('connectionsUnit');

  const loadinUser = Object.keys(user).length === 0;

  const [Unidades, setUnidades] = useState([]);

  const saveUnit = (unit, id) => {
    sessionStorage.setItem('connectionsUnit', unit);
    sessionStorage.setItem('connectionsUnitId', id);
    navigate(`/${unit}`);
  };

  const ListUnidades = useCallback(async () => {
    try {
      const response = await apiJalles.get('unidade/LeituraTodos', headerApi);
      // const unidadesCompatíveis = response.data.filter((obj) =>
      //   user.unidades.includes(obj.id)
      // );
      setUnidades(response.data);
      // setUnidades(unidadesCompatíveis);
      // console.log(response.data);
    } catch (error) {
      toast.warn('Não foi possível carregar as unidades.', {
        position: 'top-right',
        autoClose: 3000,
        theme: 'light',
      });
    }
  }, [headerApi]);

  useEffect(() => {
    if (unityExists) {
      navigate(`/${unityExists}`);
    }

    if (!loadinUser) {
      ListUnidades();
    }
  }, [ListUnidades, navigate, unityExists, loadinUser]);

  return (
    <HomeMain>
      <div className="background">
        <img src={logo} alt="" />
        <div
          onClick={() => {
            sessionStorage.clear();
            navigate('/Login');
          }}
        >
          <button>Sair</button>
          <IoExit />
        </div>
      </div>
      <div className="container">
        <h2>Bem Vindo ao Sistema de Controle Jalles Machado</h2>
        <p>Selecione uma das Unidades abaixo</p>
        <div className="containerButtons">
          {Unidades.map((unidade) => {
            return (
              <div className="buttons" key={unidade.id}>
                <button onClick={() => saveUnit(unidade.url, unidade.id)}>{unidade.name}</button>
              </div>
            );
          })}
        </div>
      </div>
      <Footer relative={true} />
    </HomeMain>
  );
};
